<template>
  <div class="d-flex">
    <div>
      <span class="fa-stack">
        <i class="fas fa-circle fa-stack-2x text-muted"></i>
        <i
          :class="[
            origin[accountTransaction.origin].icon,
            'fa-stack-1x fa-inverse',
          ]"
        ></i>
      </span>
    </div>
    <div class="ml-2">
      <span v-if="isIncomingTransfer"> Entrada de Transferência </span>
      <span v-else> Saída de Transferência </span>
      <br />
      <small>
        {{ originAccountDescription }} <i class="fas fa-arrow-right mr-1 ml-1" /> {{ destinationAccountDescription }}
      </small>
      <button
        class="btn btn-sm btn-link text-info"
        v-if="accountTransaction.origin == 'br'"
        @click.stop="openBillPaymentModal(accountTransaction.id)"
      >
        Ver contas
      </button>
      <span
        v-if="accountTransaction.status == 'c'"
        class="badge badge-danger ml-2"
        >Cancelado</span
      >
      <template v-if="accountTransaction.account_plan_id">
        <br />
        <small>
          {{ accountTransaction.account_plan_description }}
        </small>
      </template>
      <br />
      <small class="text-muted"
        >{{ accountTransaction.paid_at | dateBr }}</small
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accountTransaction: {},
  },

  data: () => ({
    origin: {
      o: {
        text: "Vendas",
        icon: "fas fa-shopping-cart",
      },
      br: {
        text: "Contas a receber",
        icon: "fas fa-file-invoice-dollar",
      },
      bp: {
        text: "Contas a pagar",
        icon: "fas fa-file-invoice-dollar",
      },
      c: {
        text: "Lançamento",
        icon: "fas fa-pen",
      },
      t: {
        text: "Transferência",
        icon: "fas fa-exchange-alt",
      },
      dd: {
        text: "Ajuste de Caixa",
        icon: "fas fa-hand-holding-usd",
      },
    },
  }),

  computed: {
    isIncomingTransfer() {
      return this.accountTransaction.transfer_origin_account_id;
    },

    originAccountDescription() {
      if (this.isIncomingTransfer) {
        return this.accountTransaction.transfer_origin_account.description;
      } else {
        return this.accountTransaction.account.description;
      }
    },

    destinationAccountDescription() {
      if (this.isIncomingTransfer) {
        return this.accountTransaction.account.description;
        } else {
        return this.accountTransaction.transfer_destination_account.description;
      }
    },
  },
};
</script>

<style>
</style>